import Skeleton from "react-loading-skeleton";

function SizeSelectSection({
  localLoading,
  productDetails,
  selectedSize,
  setSelectedSize,
  unit,
  setUnit,
  sizeSelection,
  setQuantity
}) {

  const sizes = productDetails?.product_sizes || [];

  const handleSizeClick = (size) => {
    if (!size || selectedSize?.id === size.id) return;
    // store selected size
    localStorage.setItem("selectedSizeId", size.id);

    setSelectedSize(size);
    // parent hook
    sizeSelection(size);

    // reset quantity
    setQuantity(1);
  };

  if (localLoading) {
    return (
      <div className="size-selector">
        <p>
          <Skeleton width={150} />
        </p>

        <div style={{ display: "flex", gap: 10 }}>
          {Array(3)
            .fill(0)
            .map((_, i) => (
              <Skeleton key={i} width={60} height={60} />
            ))}
        </div>
      </div>
    );
  }

  if (!sizes.length || selectedSize?.size === "NA") return null;

  return (
    <div className="size-selector">

      {/* LABEL */}

      {productDetails?.category_action_url === "dustbins" ? (
        <p className="selected-size-label">
          Choose Capacity:&nbsp;
          <strong style={{ fontSize: "16px", fontWeight: "600" }}>{selectedSize?.capacity}</strong>
        </p>
      ) : productDetails?.category_action_url === "floor-covering" ? (
        <p className="selected-size-label">
          Select Size :&nbsp;
          <strong style={{fontWeight: 600 }}>
            {unit === "cm"
              ? selectedSize?.size
              : unit === "ft"
                ? selectedSize?.size_in_feet
                : ""}
          </strong>
        </p>
      ) : (
        <p className="selected-size-label">
          Select Size :&nbsp;
          <strong style={{fontWeight: 600 }}>{selectedSize?.size}</strong>
        </p>
      )}

      {/* UNIT SWITCH */}

      {productDetails?.category_action_url === "floor-covering" && (
        <div className="unit-toggle">
          <button
            className={unit === "cm" ? "active" : ""}
            onClick={() => setUnit("cm")}
          >
            Cm
          </button>

          <button
            className={unit === "ft" ? "active" : ""}
            onClick={() => setUnit("ft")}
          >
            Feet
          </button>
        </div>
      )}

      {/* SIZE BUTTONS */}

      <div className="size-options">
        {sizes.map((size) => (
          <div
            key={size.id}
            className={`size-btn ${selectedSize?.id === size.id ? "active-size" : ""
              }`}
            onClick={() => handleSizeClick(size)}
          >

            <div className="set_btn_trcak">
              {size?.size_vector_media && (
                <img
                  src={size.size_vector_media}
                  className="size-image"
                  alt={size.size}
                />
              )}
            </div>

            {productDetails?.category_action_url === "dustbins" ? (
              <div className="lbl-track">{size.capacity}</div>
            ) : productDetails?.category_action_url === "floor-covering" ? (
              <div className="lbl-track">
                {unit === "cm"
                  ? size.size
                  : unit === "ft"
                    ? size.size_in_feet
                    : ""}
              </div>
            ) : (
              <div className="lbl-track">{size.size}</div>
            )}

          </div>
        ))}
      </div>

    </div>
  );
}

export default SizeSelectSection;